<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button v-if="$_allowDeleting(source)" class="btn btn-danger btn-sm" @click="$_deleteEntity(`media/audio/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Years</label>
                  <div class="col-md-10">
                    <input
                      id="date"
                      v-model="entity.date"
                      type="text"
                      placeholder="Enter date years"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Audio file *</label>
                  <div class="col-md-10">
                    <FileUploader
                      v-model="audioFile"
                      check-type="media_audio"
                      path-prefix="aud"
                      :default-file="source.mediaFile"
                      :dropzone-options="dropzoneOptions"
                      :uploading-file="uploadingFile || null"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Album</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.album"
                      :default-options="defaultOptions.audioAlbums"
                      :search-function="albumSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Transcription</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.transcription"
                      :default-options="defaultOptions.docs"
                      :search-function="transcriptionSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Audio has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import FileUploader from '@/global/components/FileUploader/Index';
import SelectRemote from '@/global/components/SelectRemote';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';

const { SUCCESS } = uploadStatus;

export default {
  name: 'AudioEdit',

  components: {
    FileUploader,
    'select-remote': SelectRemote,
    referencer: Referencer,
    terms: Terms,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [EditPageMixin, DefaultOptionsRequests, CommonPageMixin],

  data() {
    return {
      currentFile: null,
      uploadedFile: null,
      audioFile: null,
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'audio/*',
      },
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
        },
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}media/audio/${this.$route.params.id}/file`,
        paramName: 'mediaFile',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        acceptedFiles: this.dropzoneSettings.acceptedFiles,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFile() {
      const getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'media_audio');
    },
  },

  watch: {
    uploadingFile: {
      handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          this.uploadedFile = val.file;
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.$_getDefaultAlbums();
    this.$_getDefaultDocuments();
  },

  methods: {
    albumSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/audio-albums?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    transcriptionSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/documents?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio/${this.$route.params.id}`, {
        params: {
          with: ['references', 'mediaFile', 'album', 'terms', 'path_alias', 'transcription', 'featured'],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        if (this.entity.mediaFile) {
          setTimeout(this.manuallyAddFiles, 100);
        }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting audio request' });
        console.error(error);
      });
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.audioFile.uploadType === 'url' && this.audioFile.fileLink) {
        postFormData.append('selectel_file_url', this.audioFile.fileLink);
      }
      postFormData.append('album_id', this.entity.album ? +this.entity.album.id : '');
      postFormData.append('transcription', this.entity.transcription ? this.entity.transcription.id : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/audio/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { file, uploadType } = this.audioFile;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { currentFile } = this;
      const { acceptedFiles } = this.dropzoneOptions;
      const entityId = this.$route.params.id;
      const vm = this;
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (!file) return;
        const isFileChanged = file.name !== (currentFile ? currentFile.name : '');
        if (isFileChanged && uploadType === 'file') {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId,
            files: [file],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
          vm.currentFile = file;
        }
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update article query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?fbc7a6c8